module.exports = __webpack_public_path__ + "img/account-upgrade-icon.6c4133e9.svg";